export function NoAccess() {
  return (
    <>
      <p>You do not have permission to access this page.</p>
      <p>Need access? Contact your administrator or check if you're signed in to the correct account.</p>
    </>
  );
}
